import React from 'react';

/**
 * HOC that wraps TopBarPagoMenu to inject backendSpecs actions and selectors
 */
const TopBarPagoMenuWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { backendSpecsActions, backendSpecsSelectors, pagoAuth2Selectors } = system;

    return (
      <Original
        {...props}
        backendSpecsActions={backendSpecsActions}
        backendSpecsSelectors={backendSpecsSelectors}
        pagoAuth2Selectors={pagoAuth2Selectors}
      />
    );
  };

  return Wrapper;
};

export default TopBarPagoMenuWrapper;
